/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Quima_backend
 * OpenAPI spec version: v1
 */
import axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AssetStatus,
  CuratorAcceptRequestDto,
  CuratorRejectRequestDto,
  EditAssetDto,
  GetApiAssetDownloadSubtitleParams,
  GetApiAssetFilterParams,
  GetApiAssetSearchParams,
  PostApiAssetChangeSubtitleLanguageSubtitleIdParams,
  PostApiAssetEncodeParams,
  PostApiAssetUploadHeroImageBody,
  PostApiAssetUploadMainVideoBody,
  PostApiAssetUploadSubtitleBody,
  PostApiAssetUploadThumbnailBody,
  PostApiAssetUploadTrailerBody,
  SaveAssetDto
} from '../generated.schemas';




  export const getAsset = (axiosInstance: AxiosInstance = axios) => {
/**
 * @summary Creates a new asset upload entry in the database with default values.
 */
const postApiAssetCreate = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/create`,undefined,options
    );
  }
/**
 * @summary Uploads a main video file for a specific asset upload ID.
 */
const postApiAssetUploadMainVideo = (
    postApiAssetUploadMainVideoBody: PostApiAssetUploadMainVideoBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postApiAssetUploadMainVideoBody.ContentType !== undefined) {
 formData.append(`ContentType`, postApiAssetUploadMainVideoBody.ContentType);
 }
if(postApiAssetUploadMainVideoBody.ContentDisposition !== undefined) {
 formData.append(`ContentDisposition`, postApiAssetUploadMainVideoBody.ContentDisposition);
 }
if(postApiAssetUploadMainVideoBody.Headers !== undefined) {
 formData.append(`Headers`, JSON.stringify(postApiAssetUploadMainVideoBody.Headers));
 }
if(postApiAssetUploadMainVideoBody.Length !== undefined) {
 formData.append(`Length`, postApiAssetUploadMainVideoBody.Length.toString())
 }
if(postApiAssetUploadMainVideoBody.Name !== undefined) {
 formData.append(`Name`, postApiAssetUploadMainVideoBody.Name);
 }
if(postApiAssetUploadMainVideoBody.FileName !== undefined) {
 formData.append(`FileName`, postApiAssetUploadMainVideoBody.FileName);
 }
if(postApiAssetUploadMainVideoBody.assetUploadId !== undefined) {
 formData.append(`assetUploadId`, postApiAssetUploadMainVideoBody.assetUploadId.toString())
 }

    return axiosInstance.post(
      `/api/Asset/upload-main-video`,
      formData,options
    );
  }
/**
 * @summary Uploads a trailer video file for a specific asset upload ID.
 */
const postApiAssetUploadTrailer = (
    postApiAssetUploadTrailerBody: PostApiAssetUploadTrailerBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postApiAssetUploadTrailerBody.ContentType !== undefined) {
 formData.append(`ContentType`, postApiAssetUploadTrailerBody.ContentType);
 }
if(postApiAssetUploadTrailerBody.ContentDisposition !== undefined) {
 formData.append(`ContentDisposition`, postApiAssetUploadTrailerBody.ContentDisposition);
 }
if(postApiAssetUploadTrailerBody.Headers !== undefined) {
 formData.append(`Headers`, JSON.stringify(postApiAssetUploadTrailerBody.Headers));
 }
if(postApiAssetUploadTrailerBody.Length !== undefined) {
 formData.append(`Length`, postApiAssetUploadTrailerBody.Length.toString())
 }
if(postApiAssetUploadTrailerBody.Name !== undefined) {
 formData.append(`Name`, postApiAssetUploadTrailerBody.Name);
 }
if(postApiAssetUploadTrailerBody.FileName !== undefined) {
 formData.append(`FileName`, postApiAssetUploadTrailerBody.FileName);
 }
if(postApiAssetUploadTrailerBody.assetUploadId !== undefined) {
 formData.append(`assetUploadId`, postApiAssetUploadTrailerBody.assetUploadId.toString())
 }

    return axiosInstance.post(
      `/api/Asset/upload-trailer`,
      formData,options
    );
  }
/**
 * @summary Uploads a hero image for a specific asset upload ID.
 */
const postApiAssetUploadHeroImage = (
    postApiAssetUploadHeroImageBody: PostApiAssetUploadHeroImageBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postApiAssetUploadHeroImageBody.ContentType !== undefined) {
 formData.append(`ContentType`, postApiAssetUploadHeroImageBody.ContentType);
 }
if(postApiAssetUploadHeroImageBody.ContentDisposition !== undefined) {
 formData.append(`ContentDisposition`, postApiAssetUploadHeroImageBody.ContentDisposition);
 }
if(postApiAssetUploadHeroImageBody.Headers !== undefined) {
 formData.append(`Headers`, JSON.stringify(postApiAssetUploadHeroImageBody.Headers));
 }
if(postApiAssetUploadHeroImageBody.Length !== undefined) {
 formData.append(`Length`, postApiAssetUploadHeroImageBody.Length.toString())
 }
if(postApiAssetUploadHeroImageBody.Name !== undefined) {
 formData.append(`Name`, postApiAssetUploadHeroImageBody.Name);
 }
if(postApiAssetUploadHeroImageBody.FileName !== undefined) {
 formData.append(`FileName`, postApiAssetUploadHeroImageBody.FileName);
 }
if(postApiAssetUploadHeroImageBody.assetUploadId !== undefined) {
 formData.append(`assetUploadId`, postApiAssetUploadHeroImageBody.assetUploadId.toString())
 }

    return axiosInstance.post(
      `/api/Asset/upload-hero-image`,
      formData,options
    );
  }
/**
 * @summary Uploads a thumbnail image for a specific asset upload ID.
 */
const postApiAssetUploadThumbnail = (
    postApiAssetUploadThumbnailBody: PostApiAssetUploadThumbnailBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postApiAssetUploadThumbnailBody.ContentType !== undefined) {
 formData.append(`ContentType`, postApiAssetUploadThumbnailBody.ContentType);
 }
if(postApiAssetUploadThumbnailBody.ContentDisposition !== undefined) {
 formData.append(`ContentDisposition`, postApiAssetUploadThumbnailBody.ContentDisposition);
 }
if(postApiAssetUploadThumbnailBody.Headers !== undefined) {
 formData.append(`Headers`, JSON.stringify(postApiAssetUploadThumbnailBody.Headers));
 }
if(postApiAssetUploadThumbnailBody.Length !== undefined) {
 formData.append(`Length`, postApiAssetUploadThumbnailBody.Length.toString())
 }
if(postApiAssetUploadThumbnailBody.Name !== undefined) {
 formData.append(`Name`, postApiAssetUploadThumbnailBody.Name);
 }
if(postApiAssetUploadThumbnailBody.FileName !== undefined) {
 formData.append(`FileName`, postApiAssetUploadThumbnailBody.FileName);
 }
if(postApiAssetUploadThumbnailBody.assetUploadId !== undefined) {
 formData.append(`assetUploadId`, postApiAssetUploadThumbnailBody.assetUploadId.toString())
 }

    return axiosInstance.post(
      `/api/Asset/upload-thumbnail`,
      formData,options
    );
  }
/**
 * @summary Uploads a subtitle file for a specific asset upload ID.
 */
const postApiAssetUploadSubtitle = (
    postApiAssetUploadSubtitleBody: PostApiAssetUploadSubtitleBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postApiAssetUploadSubtitleBody.ContentType !== undefined) {
 formData.append(`ContentType`, postApiAssetUploadSubtitleBody.ContentType);
 }
if(postApiAssetUploadSubtitleBody.ContentDisposition !== undefined) {
 formData.append(`ContentDisposition`, postApiAssetUploadSubtitleBody.ContentDisposition);
 }
if(postApiAssetUploadSubtitleBody.Headers !== undefined) {
 formData.append(`Headers`, JSON.stringify(postApiAssetUploadSubtitleBody.Headers));
 }
if(postApiAssetUploadSubtitleBody.Length !== undefined) {
 formData.append(`Length`, postApiAssetUploadSubtitleBody.Length.toString())
 }
if(postApiAssetUploadSubtitleBody.Name !== undefined) {
 formData.append(`Name`, postApiAssetUploadSubtitleBody.Name);
 }
if(postApiAssetUploadSubtitleBody.FileName !== undefined) {
 formData.append(`FileName`, postApiAssetUploadSubtitleBody.FileName);
 }
if(postApiAssetUploadSubtitleBody.assetUploadId !== undefined) {
 formData.append(`assetUploadId`, postApiAssetUploadSubtitleBody.assetUploadId.toString())
 }

    return axiosInstance.post(
      `/api/Asset/upload-subtitle`,
      formData,options
    );
  }
/**
 * @summary Saves the asset as a draft.
 */
const postApiAssetSaveDraft = (
    saveAssetDto: SaveAssetDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/save-draft`,
      saveAssetDto,options
    );
  }
/**
 * @summary Submits the asset for processing.
 */
const postApiAssetSubmit = (
    saveAssetDto: SaveAssetDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/submit`,
      saveAssetDto,options
    );
  }
/**
 * @summary Edits an existing asset based on the provided asset ID and edit DTO.
 */
const putApiAssetEditAsetAssetId = (
    assetId: number,
    editAssetDto: EditAssetDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(
      `/api/Asset/editAset/${assetId}`,
      editAssetDto,options
    );
  }
/**
 * @summary Verifies the token provided in the request header.
 */
const postApiAssetVerify = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/verify`,undefined,options
    );
  }
/**
 * @summary Retrieves all assets uploaded by the user.
 */
const getApiAssetGetAllAssets = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/get-all-assets`,options
    );
  }
/**
 * @summary Retrieves the details of a specific asset by its ID.
 */
const getApiAssetAssetUploadIdDetails = (
    assetUploadId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/${assetUploadId}/details`,options
    );
  }
/**
 * @summary Filters assets based on content format, category, and status.
 */
const getApiAssetFilter = (
    params?: GetApiAssetFilterParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/filter`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @deprecated
 * @summary Initiates the encoding process for a specific asset.
 */
const postApiAssetEncode = (
    params?: PostApiAssetEncodeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/encode`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Curator/admin accept action that validates review state and delegates to encoding.
 */
const postApiAssetReviewAccept = (
    curatorAcceptRequestDto: CuratorAcceptRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/review/accept`,
      curatorAcceptRequestDto,options
    );
  }
/**
 * @summary Curator/admin reject action that verifies review state and delegates to the status transition service.
 */
const postApiAssetReviewReject = (
    curatorRejectRequestDto: CuratorRejectRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/review/reject`,
      curatorRejectRequestDto,options
    );
  }
/**
 * @summary Streams the encoding progress for a specific asset and video ID.
 */
const getApiAssetProgressStreamAssetIdVideoId = (
    assetId: number,
    videoId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/progress-stream/${assetId}/${videoId}`,options
    );
  }
/**
 * @summary Deletes a subtitle by its ID.
 */
const deleteApiAssetDeleteSubtitleSubtitleId = (
    subtitleId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/api/Asset/delete-subtitle/${subtitleId}`,options
    );
  }
/**
 * @summary Deletes an asset by its ID.
 */
const deleteApiAssetAssetDeleteId = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/api/Asset/asset-delete/${id}`,options
    );
  }
/**
 * @summary Searches for assets based on a query string for the title.
 */
const getApiAssetSearch = (
    params?: GetApiAssetSearchParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Gets all assets filtered by status.
 */
const getApiAssetGetByStatusStatus = (
    status: AssetStatus, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/get-by-status/${status}`,options
    );
  }
/**
 * @summary Curator/admin queue: assets awaiting review (same data as get-by-status/UnderReview).
 */
const getApiAssetGetQueueUnderReview = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/get-queue-under-review`,options
    );
  }
/**
 * @summary Retrieves all assets uploaded by the authenticated user based on their token.
 */
const getApiAssetGetAssetsByUserToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/getAssetsByUserToken`,options
    );
  }
const getApiAssetDownloadSubtitle = (
    params?: GetApiAssetDownloadSubtitleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Asset/downloadSubtitle`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Changes the language of a subtitle by its ID.
 */
const postApiAssetChangeSubtitleLanguageSubtitleId = (
    subtitleId: number,
    params?: PostApiAssetChangeSubtitleLanguageSubtitleIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Asset/change-subtitle-language/${subtitleId}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
return {postApiAssetCreate,postApiAssetUploadMainVideo,postApiAssetUploadTrailer,postApiAssetUploadHeroImage,postApiAssetUploadThumbnail,postApiAssetUploadSubtitle,postApiAssetSaveDraft,postApiAssetSubmit,putApiAssetEditAsetAssetId,postApiAssetVerify,getApiAssetGetAllAssets,getApiAssetAssetUploadIdDetails,getApiAssetFilter,postApiAssetEncode,postApiAssetReviewAccept,postApiAssetReviewReject,getApiAssetProgressStreamAssetIdVideoId,deleteApiAssetDeleteSubtitleSubtitleId,deleteApiAssetAssetDeleteId,getApiAssetSearch,getApiAssetGetByStatusStatus,getApiAssetGetQueueUnderReview,getApiAssetGetAssetsByUserToken,getApiAssetDownloadSubtitle,postApiAssetChangeSubtitleLanguageSubtitleId}};
export type PostApiAssetCreateResult = AxiosResponse<void>
export type PostApiAssetUploadMainVideoResult = AxiosResponse<void>
export type PostApiAssetUploadTrailerResult = AxiosResponse<void>
export type PostApiAssetUploadHeroImageResult = AxiosResponse<void>
export type PostApiAssetUploadThumbnailResult = AxiosResponse<void>
export type PostApiAssetUploadSubtitleResult = AxiosResponse<void>
export type PostApiAssetSaveDraftResult = AxiosResponse<void>
export type PostApiAssetSubmitResult = AxiosResponse<void>
export type PutApiAssetEditAsetAssetIdResult = AxiosResponse<void>
export type PostApiAssetVerifyResult = AxiosResponse<void>
export type GetApiAssetGetAllAssetsResult = AxiosResponse<void>
export type GetApiAssetAssetUploadIdDetailsResult = AxiosResponse<void>
export type GetApiAssetFilterResult = AxiosResponse<void>
export type PostApiAssetEncodeResult = AxiosResponse<void>
export type PostApiAssetReviewAcceptResult = AxiosResponse<void>
export type PostApiAssetReviewRejectResult = AxiosResponse<void>
export type GetApiAssetProgressStreamAssetIdVideoIdResult = AxiosResponse<void>
export type DeleteApiAssetDeleteSubtitleSubtitleIdResult = AxiosResponse<void>
export type DeleteApiAssetAssetDeleteIdResult = AxiosResponse<void>
export type GetApiAssetSearchResult = AxiosResponse<void>
export type GetApiAssetGetByStatusStatusResult = AxiosResponse<void>
export type GetApiAssetGetQueueUnderReviewResult = AxiosResponse<void>
export type GetApiAssetGetAssetsByUserTokenResult = AxiosResponse<void>
export type GetApiAssetDownloadSubtitleResult = AxiosResponse<void>
export type PostApiAssetChangeSubtitleLanguageSubtitleIdResult = AxiosResponse<void>
